import { render, staticRenderFns } from "./file-record.vue?vue&type=template&id=73073195&scoped=true&"
import script from "./file-record.vue?vue&type=script&lang=js&"
export * from "./file-record.vue?vue&type=script&lang=js&"
import style0 from "./file-record.vue?vue&type=style&index=0&id=73073195&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73073195",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73073195')) {
      api.createRecord('73073195', component.options)
    } else {
      api.reload('73073195', component.options)
    }
    module.hot.accept("./file-record.vue?vue&type=template&id=73073195&scoped=true&", function () {
      api.rerender('73073195', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chatLog/lib/file-record.vue"
export default component.exports